import axios from "axios";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? `${window.location.origin}/api`
      : "http://85.217.170.83/api",

  withCredentials: true,
  timeout: 10000, // 10 seconds timeout to prevent hanging requests
});

// Request interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Remove automatic logout on 401 errors
    // Only reject the promise, don't redirect
    return Promise.reject(error);
  }
);

export default API;
